function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, watch, ref, getCurrentInstance } from "vue";
import { getCommonAssetModelInfo } from "@/api/common/asset";
import { getCommonComponentList } from "@/api/common/asset";
import { assetCallbackModel } from "@/store/creative/asset";
import { isPresetPrefix } from "@/views/creative/utils/preset-utils";
import useIdToFindResourceList from "@/views/creative/utils/use-id-to-find-resource-list.js";
import { t } from "@/lang";
import { useModelStore } from "@/views/creative/model-editor/model-mixin";
import { getJsonModelPath } from "@/views/creative/utils";
import { assetsList } from "@pt/api/assets";
export default defineComponent({
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var isUpdatable = ref(false);
        var _$ref = useModelStore(store), category = _$ref.category, resource = _$ref.resource;
        var currentResource = computed(function() {
            return resource.value[category.value.id][0];
        });
        var template = computed(function() {
            return store.state.creative.template;
        });
        var templateConfig = computed(function() {
            return store.state.creative.template.templateConfig;
        });
        var resourceList = computed(function() {
            if (templateConfig.value && category.value) {
                var list = useIdToFindResourceList({
                    resource: templateConfig.value.resource,
                    id: category.value.id
                });
                return list;
            }
            return [];
        });
        var isPresetPrefixs = computed(function() {
            return resourceList.value && isPresetPrefix(resourceList.value[0].prefix);
        });
        watch(function() {
            return store.state.creative.modelEditor.visible;
        }, function(value) {
            if (value) {
                if (root.hasPermission("resource.basic-resource-updatable")) {
                    isUpdatable.value = true;
                } else {
                    isUpdatable.value = currentResource.value && currentResource.value.is_basic !== 1;
                }
            }
        });
        function handleOpenAssetDialog() {
            return _handleOpenAssetDialog.apply(this, arguments);
        }
        function _handleOpenAssetDialog() {
            _handleOpenAssetDialog = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var maxSize, model, modelInfo;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            maxSize = 5 * 1024 * 1024;
                            model = {
                                order: "-updated_time",
                                formats: [
                                    "zip"
                                ],
                                type: "model",
                                size_max: maxSize,
                                skeleton_type: ""
                            };
                            _ctx1.next = 4;
                            return getCommonAssetModelInfo({
                                name: category.value.prefix
                            });
                        case 4:
                            modelInfo = _ctx1.sent;
                            model.skeleton_type = modelInfo.data.data.skeleton_type;
                            store.commit("creative/asset/updateResourceManagerDialog", {
                                visible: true,
                                model: model,
                                defaultTab: "commonModel",
                                tabKeyList: [
                                    "commonModel",
                                    "assetModel"
                                ]
                            });
                            // @ts-ignore
                            // eslint-disable-next-line no-undef
                            assetCallbackModel.submit = function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                                    var submitCallback, res, postData, isGm;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                submitCallback = function() {
                                                    assetCallbackModel.loading = false;
                                                };
                                                if (!assetCallbackModel.loading) {
                                                    _ctx.next = 3;
                                                    break;
                                                }
                                                return _ctx.abrupt("return");
                                            case 3:
                                                assetCallbackModel.loading = true;
                                                _ctx.prev = 4;
                                                ;
                                                if (!(file.type === "common")) {
                                                    _ctx.next = 12;
                                                    break;
                                                }
                                                _ctx.next = 9;
                                                return getCommonComponentList({
                                                    tool: 1,
                                                    id: file.file.id
                                                });
                                            case 9:
                                                res = _ctx.sent;
                                                _ctx.next = 16;
                                                break;
                                            case 12:
                                                postData = {
                                                    keyword: file.id,
                                                    search_field: "id"
                                                };
                                                _ctx.next = 15;
                                                return assetsList(postData);
                                            case 15:
                                                res = _ctx.sent;
                                            case 16:
                                                if (!(res.data && res.data && res.data.data.total === 0)) {
                                                    _ctx.next = 20;
                                                    break;
                                                }
                                                submitCallback();
                                                root.$message.error(String(t("playTurbo.custom.resourceUploader.assetNotExist")));
                                                return _ctx.abrupt("return");
                                            case 20:
                                                _ctx.next = 28;
                                                break;
                                            case 22:
                                                _ctx.prev = 22;
                                                _ctx.t0 = _ctx["catch"](4);
                                                submitCallback();
                                                console.error(_ctx.t0);
                                                root.$message.error(String(t("playTurbo.custom.resourceUploader.assetNotExist")));
                                                return _ctx.abrupt("return");
                                            case 28:
                                                isGm = template.value.isGeneralTemplateService;
                                                // 选择资源库里面的  gltf 之后
                                                store.dispatch("creative/modelEditor/openModelEditorByGltf", {
                                                    fileUrl: file.file.file_url,
                                                    filePath: currentResource.value.real_file_path,
                                                    mod: isGm ? "gm" : "dm",
                                                    model: getJsonModelPath(resourceList.value[0].file_path),
                                                    tplId: template.value.templateId,
                                                    preset: isPresetPrefixs.value ? 1 : 0,
                                                    resId: file.file.id,
                                                    thumbUrl: file.file.thumb_url,
                                                    categoryId: category.value.id
                                                });
                                                submitCallback();
                                            case 31:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            4,
                                            22
                                        ]
                                    ]);
                                }));
                                return function(file) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                        case 8:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return _handleOpenAssetDialog.apply(this, arguments);
        }
        return {
            template: template,
            category: category,
            isUpdatable: isUpdatable,
            handleOpenAssetDialog: handleOpenAssetDialog
        };
    }
});
